<style lang="scss" src='./OrderFinished.scss' scoped></style>
<template src="./OrderFinished.html"></template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations
  } from "vuex";

  import moment from 'moment';

  import { Models } from 'sr-js-lib';
  
  export default {
    name: "OrderFinished",
    components: {},
    data() {
      return {
        selected: null,
        amount: null,
        notes: null,
        complete: false,
        tempCartProducts: Models.M_cart(),
      };
    },
    computed: {
      ...mapState('CartStore' ,['cartProducts']),
    },
    methods: {
      ...mapMutations('CartStore',['setCartProducts']),
      ...mapMutations(["setCartNotes"]),

      fnGetDate(date) {
        return this.F_capitalizeAllFirst(this.F_formatDeliveryDate(date));
      },
      fnGetDateTime(dateTime) {
        return moment(dateTime, 'hh:mm:ss').format('hh:mm A');
      },
    },

    beforeCreate() {},
    created() {
      this.setCartNotes('');
      window.fbq('track', 'PageView');
    },
    mounted() {
      this.tempCartProducts = { ...this.cartProducts };
      if(this.cartProducts._id != null){
        this.setCartProducts( Models.M_cart() );
      }else{
        this.$router.push('/');
      }
    },
    beforeDestroy() {
    },
  };

</script>
